/**
 * Main JavaScript file for Socigom theme
 */

(function($) {
    'use strict';
    
    console.log('🚀 Socigom theme JavaScript loaded!');

    // Initialize Foundation
    function initFoundation() {
        if (typeof Foundation !== 'undefined') {
            $(document).foundation();
            console.log('Foundation initialized');
        }
    }

    // Mobile menu toggle
    function initMobileMenu() {
        const menuToggle = document.querySelector('.mobile-menu-toggle');
        const mobileNav = document.querySelector('.mobile-nav');
        
        console.log('🍔 Initializing mobile menu...');
        console.log('Menu toggle:', menuToggle);
        console.log('Mobile nav:', mobileNav);
        
        if (menuToggle && mobileNav) {
            // Toggle menu on button click
            menuToggle.addEventListener('click', function() {
                console.log('🍔 Menu toggle clicked!');
                menuToggle.classList.toggle('active');
                mobileNav.classList.toggle('active');
                
                // Update aria-expanded
                const isExpanded = menuToggle.classList.contains('active');
                menuToggle.setAttribute('aria-expanded', isExpanded);
                console.log('Menu is now:', isExpanded ? 'OPEN' : 'CLOSED');
            });
            
            // Close menu when clicking on menu links
            const mobileMenuLinks = mobileNav.querySelectorAll('a');
            mobileMenuLinks.forEach(function(link) {
                link.addEventListener('click', function() {
                    console.log('🍔 Menu link clicked, closing menu');
                    menuToggle.classList.remove('active');
                    mobileNav.classList.remove('active');
                    menuToggle.setAttribute('aria-expanded', 'false');
                });
            });
            
            console.log('✅ Mobile menu initialized successfully');
        } else {
            console.log('❌ Mobile menu elements not found!');
        }
    }

    // Smooth scroll for anchor links
    function initSmoothScroll() {
        const links = document.querySelectorAll('a[href^="#"]');
        
        links.forEach(link => {
            link.addEventListener('click', function(e) {
                const href = this.getAttribute('href');
                if (href === '#') return;

                const target = document.querySelector(href);
                if (target) {
                    e.preventDefault();
                    target.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            });
        });
    }

    // Fixed header that hides on scroll down and returns on scroll up
    function initHeaderScrollBehavior() {
        const header = document.querySelector('.site-header-modern');
        const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
        const mobileNav = document.querySelector('.mobile-nav');

        if (!header) return;

        let lastScrollY = window.scrollY || window.pageYOffset;
        let ticking = false;
        let headerTween = null;

        function animateHeader(isVisible) {
            if (typeof gsap === 'undefined') {
                return;
            }

            if (headerTween) {
                headerTween.kill();
            }

            headerTween = gsap.to(header, {
                yPercent: isVisible ? 0 : -100,
                opacity: isVisible ? 1 : 0,
                duration: isVisible ? 0.42 : 0.3,
                ease: isVisible ? 'power2.out' : 'power2.inOut',
                overwrite: 'auto',
                force3D: true
            });
        }

        function isMobileMenuOpen() {
            return Boolean(mobileMenuToggle && mobileMenuToggle.classList.contains('active')) || Boolean(mobileNav && mobileNav.classList.contains('active'));
        }

        function updateHeaderState() {
            const currentScrollY = window.scrollY || window.pageYOffset;
            const scrollDelta = Math.abs(currentScrollY - lastScrollY);

            if (scrollDelta < 4 && currentScrollY > 24) {
                ticking = false;
                return;
            }

            const scrollingDown = currentScrollY > lastScrollY;
            const isPastTop = currentScrollY > 24;

            if (!isPastTop) {
                animateHeader(true);
            } else if (!isMobileMenuOpen()) {
                animateHeader(!scrollingDown);
            } else {
                animateHeader(true);
            }

            lastScrollY = Math.max(currentScrollY, 0);
            ticking = false;
        }

        if (typeof gsap !== 'undefined') {
            gsap.set(header, { yPercent: 0, opacity: 1, force3D: true });
        }

        updateHeaderState();

        window.addEventListener('scroll', function() {
            if (!ticking) {
                window.requestAnimationFrame(updateHeaderState);
                ticking = true;
            }
        }, { passive: true });

        if (mobileMenuToggle && mobileNav) {
            mobileMenuToggle.addEventListener('click', function() {
                animateHeader(true);
            });
        }
    }

    // Global variables for Swiper
    let servicesSwiper = null;

    // Initialize Swiper for services gallery
    function initServicesSwiper() {
        const swiperContainer = document.querySelector('.servicesSwiper');
        if (!swiperContainer) return;

        servicesSwiper = new Swiper('.servicesSwiper', {
            direction: 'vertical',
            slidesPerView: 3,
            spaceBetween: 20,
            loop: true,
            initialSlide: 1,
            centeredSlides: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            speed: 800,
            effect: 'slide',
            allowTouchMove: false,
            simulateTouch: false,
            mousewheel: false,
        });

        console.log('🎠 Swiper initialized');
    }

    // Update service images when accordion item changes
    function updateServiceImages(item) {
        const galleryData = item.getAttribute('data-gallery');
        console.log('🖼️ Gallery data:', galleryData);
        
        if (!galleryData || !servicesSwiper) {
            console.log('❌ No gallery data or swiper not initialized');
            return;
        }

        try {
            const images = JSON.parse(galleryData);
            console.log('📸 Parsed images:', images);

            // Parar autoplay
            servicesSwiper.autoplay.stop();

            // Remover todos os slides
            servicesSwiper.removeAllSlides();

            // Adicionar novos slides
            const slides = [];
            if (images.length > 0) {
                images.forEach((imageUrl, index) => {
                    const slide = `
                        <div class="swiper-slide">
                            <div class="s-img" style="background-image: url('${imageUrl}');"></div>
                        </div>
                    `;
                    slides.push(slide);
                });
            } else {
                // Sem imagens, adicionar placeholders
                for (let i = 0; i < 6; i++) {
                    const slide = `
                        <div class="swiper-slide">
                            <div class="s-img" style="background-color: #e0e0e0;"></div>
                        </div>
                    `;
                    slides.push(slide);
                }
            }

            servicesSwiper.appendSlide(slides);
            
            // Reiniciar autoplay
            servicesSwiper.autoplay.start();
            
            console.log('✅ Swiper updated with', slides.length, 'slides');
        } catch (e) {
            console.error('❌ Error parsing gallery data:', e);
        }
    }

    // Accordion functionality for Arquitetura page
    function initAccordion() {
        console.log('🎵 Initializing accordion...');
        const accordionItems = document.querySelectorAll('.accordion-custom li');
        console.log(`📋 Found ${accordionItems.length} accordion items`);
        
        accordionItems.forEach((item, itemIndex) => {
            const heading = item.querySelector('h5');
            const galleryData = item.getAttribute('data-gallery');
            console.log(`Item ${itemIndex}: ${heading ? heading.textContent : 'no title'} - Gallery: ${galleryData ? 'yes' : 'no'}`);
            
            if (heading) {
                heading.addEventListener('click', function(e) {
                    e.preventDefault();
                    console.log('🖱️ Clicked on:', heading.textContent);
                    
                    const isActive = item.classList.contains('active');
                    
                    accordionItems.forEach(i => {
                        i.classList.remove('active');
                        const content = i.querySelector('.accordion-content');
                        if (content) {
                            content.style.maxHeight = null;
                        }
                    });
                    
                    if (!isActive) {
                        item.classList.add('active');
                        const content = item.querySelector('.accordion-content');
                        if (content) {
                            content.style.maxHeight = content.scrollHeight + 'px';
                        }

                        console.log('📸 Updating swiper slides...');
                        updateServiceImages(item);
                    }
                });
            }
        });

        const activeItem = document.querySelector('.accordion-custom li.active');
        if (activeItem) {
            const content = activeItem.querySelector('.accordion-content');
            if (content) {
                content.style.maxHeight = content.scrollHeight + 'px';
            }
            console.log('✅ Active item initialized');
        }
    }

    // Initialize Swiper for projects carousel
    function initProjetosSwiper() {
        const swiperContainer = document.querySelector('.projetosSwiper');
        if (!swiperContainer) return;

        // Contar quantos slides existem
        const slidesCount = swiperContainer.querySelectorAll('.swiper-slide').length;
        console.log('📊 Total slides:', slidesCount);

        // Loop só funciona bem quando há mais slides do que o slidesPerView
        // Se houver 3 ou menos slides, desabilitar loop para evitar bugs
        const enableLoop = slidesCount > 3;

        new Swiper('.projetosSwiper', {
            slidesPerView: 1, // 1 slide em mobile
            spaceBetween: 30,
            loop: enableLoop, // Loop dinâmico baseado no número de slides
            autoplay: enableLoop ? {
                delay: 5000,
                disableOnInteraction: false,
            } : false, // Desabilitar autoplay se não houver loop
            speed: 800,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                // >= 640px
                640: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                // >= 1024px
                1024: {
                    slidesPerView: enableLoop ? 3 : Math.min(slidesCount, 3), // Ajustar slidesPerView baseado no total
                    spaceBetween: 30,
                },
            },
        });

        console.log('🏗️ Projetos Swiper initialized - Loop:', enableLoop);
    }

    // Initialize GLightbox for project galleries
    function initProjectGalleries() {
        const projectCards = document.querySelectorAll('.project-card.has-gallery');
        
        if (projectCards.length === 0) {
            console.log('ℹ️ No project cards with galleries found');
            return;
        }

        console.log(`🖼️ Initializing GLightbox for ${projectCards.length} project cards`);

        projectCards.forEach((card, index) => {
            card.style.cursor = 'pointer';
            
            card.addEventListener('click', function(e) {
                e.preventDefault();
                
                const galleryData = this.getAttribute('data-gallery');
                
                if (!galleryData) {
                    console.log('⚠️ No gallery data found');
                    return;
                }

                try {
                    const images = JSON.parse(galleryData);
                    
                    if (images.length === 0) {
                        console.log('⚠️ Gallery is empty');
                        return;
                    }

                    // Preparar elementos para GLightbox (sem títulos)
                    const glightboxElements = images.map((img) => ({
                        'href': img.href,
                        'type': 'image'
                    }));

                    // Inicializar GLightbox com a galeria
                    const lightbox = GLightbox({
                        elements: glightboxElements,
                        loop: true,
                        touchNavigation: true,
                        closeButton: true,
                        zoomable: true,
                        draggable: true,
                        dragAutoSnap: true,
                        preload: true,
                        openEffect: 'fade',
                        closeEffect: 'fade',
                        slideEffect: 'slide',
                        skin: 'clean'
                    });

                    // Abrir lightbox
                    lightbox.open();
                    
                    console.log(`✅ Gallery opened with ${images.length} images`);
                    
                } catch (e) {
                    console.error('❌ Error opening gallery:', e);
                }
            });
        });

        console.log('✅ GLightbox initialized for all project galleries');
    }

    // Initialize GSAP entrance animations on custom templates (except Contactos)
    function initScrollAnimations() {
        if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
            console.log('ℹ️ GSAP/ScrollTrigger not available');
            return;
        }

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
        }

        const isTemplatePage = document.querySelector('main.page-grupo-socigom, main.page-arquitetura, main.page-construcao-lsf, main.page-gestao-projetos');
        const isContactosPage = document.querySelector('main.page-contactos');

        if (!isTemplatePage || isContactosPage) {
            return;
        }

        gsap.registerPlugin(ScrollTrigger);

        // Hero reveal
        const heroSection = document.querySelector('main.site-main section:first-of-type');
        if (heroSection) {
            const heroTitle = heroSection.querySelectorAll('.hero-title, .hero-quote, .hero-subtitle, .hero-author, .eyebrow, .eyebrow-white');
            const heroButton = heroSection.querySelectorAll('.hero-bottom .button, .hero-actions .button');

            gsap.from(heroTitle, {
                y: 56,
                opacity: 0,
                duration: 1,
                ease: 'power3.out',
                stagger: 0.1,
                scrollTrigger: {
                    trigger: heroSection,
                    start: 'top 78%'
                }
            });

            gsap.from(heroButton, {
                y: 24,
                scale: 0.92,
                opacity: 0,
                duration: 0.8,
                ease: 'back.out(1.4)',
                stagger: 0.08,
                scrollTrigger: {
                    trigger: heroSection,
                    start: 'top 72%'
                }
            });
        }

        // Section headers and underlines
        gsap.utils.toArray('.section-title').forEach((title) => {
            gsap.from(title, {
                y: 36,
                opacity: 0,
                duration: 0.75,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: title,
                    start: 'top 86%'
                }
            });
        });

        gsap.utils.toArray('.title-underline, .title-underline-white').forEach((line) => {
            gsap.from(line, {
                scaleX: 0,
                transformOrigin: 'left center',
                duration: 0.8,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: line,
                    start: 'top 90%'
                }
            });
        });

        // Text blocks
        gsap.utils.toArray('.manifesto-right p, .about-text-card p, .text-content, .section-subtitle').forEach((block, index) => {
            gsap.from(block, {
                y: 24,
                opacity: 0,
                duration: 0.65,
                delay: (index % 3) * 0.04,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: block,
                    start: 'top 88%'
                }
            });
        });

        // Cards with alternating lateral reveal
        gsap.utils.toArray('.custom-card, .project-card, .servico-card, .info-block').forEach((card, index) => {
            gsap.from(card, {
                x: index % 2 === 0 ? -34 : 34,
                y: 38,
                opacity: 0,
                duration: 0.85,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: card,
                    start: 'top 86%'
                }
            });
        });

        // Accordion and list items with subtle cascade
        gsap.utils.toArray('.accordion-custom li, .list-checks .cell, .processo-steps .step-item').forEach((item, index) => {
            gsap.from(item, {
                y: 18,
                opacity: 0,
                duration: 0.55,
                delay: (index % 5) * 0.05,
                ease: 'power1.out',
                scrollTrigger: {
                    trigger: item,
                    start: 'top 92%'
                }
            });
        });

        // Swiper media reveal with clip-path for stronger visual entry
        gsap.utils.toArray('.swiper .s-img, .swiper .project-img').forEach((media) => {
            gsap.from(media, {
                clipPath: 'inset(18% 8% 18% 8% round 16px)',
                scale: 1.08,
                opacity: 0,
                duration: 1,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: media,
                    start: 'top 90%'
                }
            });
        });

        ScrollTrigger.refresh();
        console.log('✨ GSAP scroll animations initialized');
    }

    // Initialize on DOM ready
    $(document).ready(function() {
        initFoundation();
        initMobileMenu();
        initSmoothScroll();
        initHeaderScrollBehavior();
        initServicesSwiper();
        initAccordion();
        initProjetosSwiper();
        initProjectGalleries();
        initScrollAnimations();
    });

})(jQuery);
